import SiteHeader from '../../components/feature/SiteHeader';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogGrid from './components/BlogGrid';
import BlogNewsletter from './components/BlogNewsletter';
import BlogCTA from './components/BlogCTA';

export default function BlogPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1">
        <BlogHero />
        <BlogGrid />
        <BlogNewsletter />
        <BlogCTA />
      </main>
      <Footer />
    </div>
  );
}
